<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeSuCloseBranchDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- CLOSE ? NO -->
    <div *ngIf="!isClose && !isLoading && !isSavedSuccessed"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100 zx-min-h-modal">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL">
            {{ "su-management.branches_close-false" | translate }}
        </h4>
        <span class="spacer"></span>
        <u>
            {{ "su-management.branches_close-msg" | translate }}
        </u>
        <form class="w-100" [formGroup]="closeBranchForm" (ngSubmit)="onCloseBranch()">
            <textarea class="form-control" [placeholder]="placeholder"
                formControlName="close_msg" name="close_msg" rows="5" required></textarea>
            <div class="d-flex flex-column flex-lg-row gap-3 align-items-center w-100 pt-5">
                <button type="submit" color="primary" mat-raised-button class="rounded-pill w-100 text-white fw-bold">
                    {{ "su-management.branches_close-close" | translate }}
                </button>
                <button type="button" color="primary" mat-button class="rounded-pill w-100 fw-bold"
                    (click)="closeSuCloseBranchDialog()">
                    {{ "su-management.branches_cancel" | translate }}
                </button>
            </div>
        </form>
    </div>
    <!-- // CLOSE ? NO -->

    <!-- CLOSE ? YES -->
    <div *ngIf="isClose && !isLoading && !isSavedSuccessed"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100 zx-min-h-modal">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL">
            {{ "su-management.branches_close-true" | translate }}
        </h4>
        <span class="spacer"></span>
        <u>
            {{ "su-management.branches_close-msg" | translate }}
        </u>
        <p class="zx-text-big">{{close_msg}}</p>
        <span class="spacer"></span>
        <div class="d-flex flex-column flex-lg-row gap-3 align-items-center w-100 pt-3">
            <button color="primary" mat-raised-button class="rounded-pill w-100 text-white fw-bold"
                (click)="onOpenBranch()">
                {{ "su-management.branches_close-open" | translate }}
            </button>
            <button color="primary" mat-button class="rounded-pill w-100 fw-bold" (click)="closeSuCloseBranchDialog()">
                {{ "su-management.branches_cancel" | translate }}
            </button>
        </div>
    </div>
    <!-- // CLOSE ? YES -->

    <!-- LOADING and SUCCESS -->
    <div *ngIf="isLoading || isSavedSuccessed"
        class="w-100 d-flex flex-column justify-content-center align-items-center zx-min-h-modal">
        <!-- loading... -->
        <mat-spinner *ngIf="!isSavedSuccessed" class="zx-small-icon-size"></mat-spinner>
        <!-- success -->
        <span class="w-100 flex-grow-1 d-flex flex-column justify-content-center align-items-center gap-3"
            *ngIf="isSavedSuccessed">
            <b class="zx-text-medium zx-text-sm-big text-green">
                {{ isClose ?
                ('su-management.branches_close-false' | translate) : ('su-management.branches_close-true' | translate)}}
            </b>
            <img src="assets/images/success-icon.svg" class="svg zx-success-icon" alt="successfull order">
        </span>
    </div>
    <!-- // LOADING and SUCCESS -->

</div>